var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup22(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 119.984,
    height: 169.141,
    viewBox: "0 0 119.984 169.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(1036.699 -1297.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M119.2,357.442h-.538v-34.19a26.239,26.239,0,0,0-26.241-26.241h-26a26.239,26.239,0,0,0-26.241,26.241v34.19H39.64a20.213,20.213,0,0,0-20.214,20.214v68.282A20.213,20.213,0,0,0,39.64,466.152h79.553a20.217,20.217,0,0,0,20.217-20.216v-68.28A20.215,20.215,0,0,0,119.2,357.442m-35.4,57.006v12.447a4.376,4.376,0,1,1-8.752,0V414.448a12.372,12.372,0,1,1,8.752,0m20.938-57.006H54.1V324.094A14.093,14.093,0,0,1,68.194,310H90.64a14.092,14.092,0,0,1,14.091,14.092Z",
    transform: "translate(-1056.125 999.996)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup22);
export default __webpack_public_path__ + "static/media/Group22.152ae445ea9a4a53a268e4b45e5d483b.svg";
export { ForwardRef as ReactComponent };